import type { IllustrationProps as SvgIllustrationProps } from "@obs/icons";
import { measure } from "@obs/tokens/index.stylex.ts";
import type { StyleXStyles } from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";
import type { ComponentType } from "react";

export type IllustrationProps = {
	illustration: ComponentType<SvgIllustrationProps>;
	sx?: StyleXStyles;
} & SvgIllustrationProps;

const styles = stylex.create({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		maxWidth: "375px",
		marginInline: "auto",
		paddingBlock: measure.spacingGapDefault,
	},
});

export const Illustration = ({ illustration: SvgComponent, sx, ...svgProps }: IllustrationProps) => {
	return (
		<div {...stylex.props(styles.root, sx)}>
			<SvgComponent {...svgProps} />
		</div>
	);
};
